<template>

    <div>

        <div class="main-wrapper" v-if="pageVersion === 'a'">

            <link rel="canonical" href="https://www.cleanfox.io"/>

            <div class="landing-header">

                <img class="logo-header img-noselect" v-lazy="lazy('/img/logo/large/white.svg')" alt="cleanfox logo">

            </div>

            <div class="landing-maintenance" v-if="isMaintenance">

                <span class="landing-maintenance-text">{{ $t('maintenance_title') }} {{ $t('maintenance_text_return') }} {{ $t('maintenance_text_thanks') }}</span>

            </div>

            <div class="ml-bloc-container">

                <div>

                    <h1 class="ml-bloc-title">{{ $t('landing_web_title') }}</h1>

                    <h2 v-if="$mq === 'lg'" class="ml-bloc-title-2">{{ $t('landing_web_subtitle') }}</h2>

                </div>

                <div class="ml-bloc-button-container">

                    <a class="btn btn-big btn-dark ml-btn" :href="hrefConnect()">{{ $t('landing_web_magic_cta_start')
                        }}</a>

                    <a
                            class="btn btn-big btn-clear ml-btn button-no-border"
                            :href="hrefMagicLink()">{{ $t('landing_web_magic_cta_already_used') }}</a>

                </div>

                <p v-if="$mq !== 'lg'" class="ml-bloc-secure">{{ $t('login_secure') }}</p>
                <p v-else></p>

            </div>


            <div class="divider"></div>

            <div class="bloc-2-background">

                <div class="wrapper-desktop">

                    <p class="bubble-text seen-in">{{ $t('landing_web_seen_in') }}</p>

                    <div class="flex-collumn bloc-2 wrapper-desktop">

                        <div class="bloc-logos">

                            <img class="img-logo img-noselect" v-lazy="lazy($t(`landing_web_media_1_picture`))"
                                 :alt="$t('landing_web_media_1_name')">

                            <img class="img-logo img-noselect" v-lazy="lazy($t(`landing_web_media_2_picture`))"
                                 :alt="$t('landing_web_media_2_name')">
                        </div>

                        <div class="bloc-logos">

                            <img class="img-logo img-noselect" v-lazy="lazy($t(`landing_web_media_3_picture`))"
                                 :alt="$t('landing_web_media_3_name')">

                            <img class="img-logo img-noselect" v-lazy="lazy($t(`landing_web_media_4_picture`))"
                                 :alt="$t('landing_web_media_4_name')">
                        </div>

                        <div class="bloc-logos">

                            <img class="img-logo img-noselect" v-lazy="lazy($t(`landing_web_media_5_picture`))"
                                 :alt="$t('landing_web_media_5_name')">

                            <img class="img-logo img-noselect" v-lazy="lazy($t(`landing_web_media_6_picture`))"
                                 :alt="$t('landing_web_media_6_name')">
                        </div>

                    </div>

                </div>

            </div>

            <div class="divider"></div>

            <div class="flex-collumn bloc-3">

                <h2 class="detect-title">{{ $t('landing_web_how_title') }}</h2>


                <!--MOBILE 3-->

                <mq-layout :mq="['sm', 'md']" class="flex-collumn">

                    <img class="detect-bubble img-noselect" src="/img/landing/bubble1.png" alt="first">

                    <span class="bubble-text">{{ $t('landing_web_how_subtitle_connect') }}</span>

                    <img class="bubble-img img-noselect" v-lazy="lazy('/img/landing/detect-connect.svg')" alt="Foxy connect">

                    <img class="detect-bubble img-noselect" src="/img/landing/bubble2.png" alt="second">

                    <span class="bubble-text">{{ $t('landing_web_how_subtitle_detects') }}</span>

                    <img class="bubble-img img-noselect" v-lazy="lazy('/img/landing/detect-auto.png')" alt="Foxy detect">

                    <img class="detect-bubble img-noselect" src="/img/landing/bubble3.png" alt="third">

                    <span class="bubble-text">{{ $t('landing_web_how_subtitle_sort') }}</span>

                    <img class="bubble-img img-noselect" v-lazy="lazy('/img/landing/detect-clean.svg')" alt="Foxy clean">

                </mq-layout>

                <!--DESKTOP 3-->

                <mq-layout mq="lg" class="wrapper-desktop flex-collumn">

                    <!--1-->

                    <div class="under-bloc-3 full">

                        <div class="flex1 ld-bloc-3-text-container">

                            <span class="bubble-text text-right">{{ $t('landing_web_how_subtitle_connect') }}</span>

                            <span class="subbubble-text text-right">{{ $t('landing_web_how_text_connect') }}</span>

                        </div>

                        <div class="detect-bubble">
                            <img src="/img/landing/bubble1.svg" class="img-noselect" alt="first">
                        </div>

                        <div class="flex1">

                            <img class="bubble-img img-noselect" v-lazy="lazy('/img/landing/detect-connect.svg')" alt="Foxy connect">

                        </div>

                    </div>

                    <!--2-->

                    <div class="under-bloc-3 under-bloc-3-top full">

                        <div class="flex1">

                            <img class="bubble-img img-noselect" v-lazy="lazy('/img/landing/detect-auto.png')" alt="Foxy detect">

                        </div>

                        <div class="detect-bubble">
                            <img src="/img/landing/bubble2.svg" class="img-noselect" alt="second">
                        </div>

                        <div class="flex1 ld-bloc-3-text-container">

                            <span class="bubble-text text-left">{{ $t('landing_web_how_subtitle_detects') }}</span>

                            <span class="subbubble-text text-left">{{ $t('landing_web_how_text_detects') }}</span>

                        </div>

                    </div>

                    <!--3-->

                    <div class="under-bloc-3 under-bloc-3-top full">

                        <div class="flex1 ld-bloc-3-text-container">

                            <span class="bubble-text text-right">{{ $t('landing_web_how_subtitle_sort') }}</span>

                            <span class="subbubble-text text-right">{{ $t('landing_web_how_text_sort') }}</span>

                        </div>

                        <div class="detect-bubble">
                            <img src="/img/landing/bubble3.svg" class="img-noselect" alt="third">
                        </div>

                        <div class="flex1">

                            <img class="bubble-img img-noselect" v-lazy="lazy('/img/landing/detect-clean.svg')" alt="Foxy clean">

                        </div>

                    </div>


                </mq-layout>

            </div>

            <div class="divider"></div>

            <div class="bloc-4">

                <!--MOBILE 4-->

                <mq-layout :mq="['sm', 'md']" class="flex-collumn">


                    <h2 class="bloc-title">{{ $t('landing_web_testimonial_title') }}</h2>

                    <landing-carrousel></landing-carrousel>

                </mq-layout>

                <!--DESKTOP 4-->

                <mq-layout mq="lg" class="wrapper-desktop ld-bloc-4">


                    <div class="flex1 under-bloc-4-left">

                        <h2 class="bloc-4-title">{{ $t('landing_web_testimonial_title') }}</h2>

                        <h2 class="bloc-4-subtitle">{{ $t('landing_web_testimonial_subtitle') }}</h2>

                        <button class="btn btn-blue btn-big btn-bloc-4-desktop" @click="wantUseCleanfox('1')">{{
                            $t('global_cta_clean') }}
                        </button>

                    </div>

                    <div class="flex1 under-bloc-4-right">

                        <landing-carrousel></landing-carrousel>

                    </div>


                </mq-layout>

            </div>


            <div class="divider"></div>

            <!-- 5 -->

            <div class="flex-collumn bloc-5">

                <h2 class="bloc-title bloc-title-5">{{ $t('global_did_you_know_title') }}</h2>

                <img class="know-img img-noselect" v-lazy="lazy('/img/foxy/glasses.svg')" alt="foxy's glasses">

                <div class="know-bloc-text">

                    <span class="know-text">{{ $t('landing_web_know_text_one_mail') }}</span>

                    <span class="know-text">{{ $t('landing_web_know_text_never_open') }}</span>

                </div>

                <button
                        class="btn btn-blue btn-know"
                        @click="wantUseCleanfox('2')"
                >
                    {{ $t('global_cta_clean') }}
                </button>

            </div>

            <div class="divider"></div>

            <!-- 6 -->

            <div class="flex-collumn bloc-6">

                <div class="flex-collumn bloc-6-desktop">

                    <h2 class="bloc-title bloc-title-6">{{ $t('landing_web_app_link_title') }}</h2>

                    <span class="native-text">{{ $t('landing_web_app_link_text') }}</span>

                    <a @click="clickAndroid" href="https://app.adjust.com/uez2im" target="_blank">
                        <img class="img-app img-app-android img-noselect" v-lazy="lazy('/img/landing/playstore.png')" alt="playstore">
                    </a>

                    <a @click="clickIos"
                       href="https://app.adjust.com/uez2im?deep_link=cleanfox://&redirect=https://itunes.apple.com/fr/app/cleanfox/id1136298377?mt=8"
                       target="_blank">
                        <img class="img-app img-app-apple img-noselect" v-lazy="lazy('/img/landing/appstore.svg')" alt="appstore">
                    </a>

                </div>

                <div class="bloc-6-desktop">

                    <img class="img-phone img-noselect" v-lazy="lazy('/img/landing/device.png')" alt="native cleanfox">

                </div>

            </div>

            <div class="divider"></div>

            <!-- 7 -->

            <div class="flex-collumn bloc-7">

                <h2 class="bloc-title bloc-7-title">{{ $t('landing_web_questions_title') }}</h2>


                <div class="bloc-7-content">

                    <div class="flex-collumn bloc-7-desktop">

                        <img class="ask-img" v-lazy="lazy('/img/icons/help-blue.svg')" alt="help">

                        <span class="bloc-ask-title">{{ $t('landing_web_questions_subtitle_clean') }}</span>

                        <span class="bloc-ask-subtitle">{{ $t('landing_web_questions_text_clean') }}</span>

                    </div>

                    <div class="flex-collumn bloc-7-desktop">

                        <img class="ask-img" v-lazy="lazy('/img/icons/cloud-blue.svg')" alt="cloud">

                        <span class="bloc-ask-title">{{ $t('landing_web_questions_subtitle_carbon') }}</span>

                        <span class="bloc-ask-subtitle">{{ $t('landing_web_questions_text_carbon') }}</span>

                    </div>

                    <div class="flex-collumn bloc-7-desktop">

                        <img class="ask-img" v-lazy="lazy('/img/icons/warning-blue.svg')" alt="warning">

                        <span class="bloc-ask-title">{{ $t('landing_web_questions_subtitle_mistake') }}</span>

                        <span class="bloc-ask-subtitle">{{ $t('landing_web_questions_text_mistake') }}</span>

                    </div>

                    <div class="flex-collumn bloc-7-desktop">

                        <img class="ask-img" v-lazy="lazy('/img/icons/trash-blue.svg')" alt="trash">

                        <span class="bloc-ask-title">{{ $t('landing_web_questions_subtitle_forever') }}</span>

                        <span class="bloc-ask-subtitle">{{ $t('landing_web_questions_text_forever') }}</span>

                    </div>
                </div>

                <img class="bloc-ask-forest" v-lazy="lazy">

            </div>

            <toast ref="toast"></toast>

            <footer-landing></footer-landing>

        </div>

        <div v-if="pageVersion === 'b'">

            <header class="landingv4__header-container">

                <img src="/img/logo/large/white.svg" class="landingv4__header-logo">

                <a class="landingv4__header-button" target="_blank" rel="magic link" href="/magic-request-email" @click="clickGA('already_used_CF')">{{ $t('landing_consent_already_used') }}</a>

            </header>

            <main class="noselect">

                <article class="article1__container">

                    <div class="article__wrapper-row">

                        <div class="article1__bloc-right">

                            <h1 class="article1__title">{{ $t('landing_consent_title_landing') }}</h1>

                            <p class="article1__subtitle">{{ $t('landing_consent_banner_description') }}</p>

                            <div class="article1__input-container" @click.self="focusInputV4">

                                <input class="article1__input" ref="inputv4" :placeholder="$t('landing_web_placeholder')" v-on:keyup.enter="goLogin($refs.inputv4.value, 'connect_email')" type="email">

                                <button class="btn btn-green btn-big article1__button" @click="goLogin($refs.inputv4.value, 'connect_email')">
                                    <lottie-loader v-if="requesting" class="btn-loader"></lottie-loader>
                                    <span :class="{ 'btn-hidden':  requesting}">{{ $t('landing_consent_cta') }}</span>
                                </button>

                                <img class="article1__input-logo" src="/img/partner/shine-white-right.svg">

                            </div>

                        </div>

                    </div>

                    <a class="article1__anchor" href="#privacy">{{ $t('landing_consent_your_data') }}</a>

                </article>

                <article class="article2__container">

                    <h2 class="article2__title">{{ $t('landing_consent_press') }}</h2>

                    <div class="article2__logo-container">

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo1.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo2.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo3.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo4.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo5.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo6.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo7.svg')"/>

                        <img class="article2__logo" v-lazy="lazy('/img/landing/logos/fr/v4/logo8.svg')"/>

                    </div>

                </article>

                <article class="article3__container">

                    <h2 class="article3__title">{{ $t('landing_consent_tuto_title') }}</h2>

                    <div class="article3__card-container">

                        <div class="article3__card">

                            <div class="article3__card-bubble">1</div>

                            <img v-lazy="lazy('/img/landing/v4/mailbox-full.svg')" class="article3__card-image">

                            <p class="article3__card-text">{{ $t('landing_consent_tuto_1') }}</p>

                        </div>

                        <div class="article3__arrow-container">

                            <img v-lazy="lazy('/img/landing/v4/arrow-1.svg')" class="article3__arrow">

                        </div>

                        <div class="article3__card">

                            <div class="article3__card-bubble">2</div>

                            <img v-lazy="lazy('/img/landing/v4/newsletters-list.svg')" class="article3__card-image">

                            <p class="article3__card-text">{{ $t('landing_consent_tuto_2') }}</p>

                        </div>

                        <div class="article3__arrow-container">

                            <img v-lazy="lazy('/img/landing/v4/arrow-2.svg')" class="article3__arrow">

                        </div>

                        <div class="article3__card">

                            <div class="article3__card-bubble">3</div>

                            <img v-lazy="lazy('/img/landing/v4/mailbox-night.svg')" class="article3__card-image">

                            <p class="article3__card-text">{{ $t('landing_consent_tuto_3') }}</p>

                        </div>


                    </div>

                </article>

                <article class="article4__container" id="privacy">

                    <h2 class="article4__title">{{ $t('your_data_title_page') }}</h2>

                    <div class="article4__bloc-left">

                        <div class="article4__card">

                            <img class="article4__card-img" src="/img/landing/card-gift.svg">

                            <span class="article4__card-text-container">

                                    <h2 class="article4__card-title">{{ $t('landing_consent_consent_title_1') }}</h2>

                                    <p class="article4__card-text">{{ $t('landing_consent_consent_description_1') }}</p>

                                </span>

                        </div>

                        <div class="article4__card">

                            <img class="article4__card-img" src="/img/landing/card-secu.svg">

                            <span class="article4__card-text-container">

                                    <h2 class="article4__card-title">{{ $t('landing_consent_consent_title_2') }}</h2>

                                    <p class="article4__card-text">{{ $t('landing_consent_consent_description_2') }}</p>

                                </span>

                        </div>

                        <div class="article4__card">

                            <img class="article4__card-img" src="/img/landing/card-safe.svg">

                            <span class="article4__card-text-container">

                                    <h2 class="article4__card-title">{{ $t('landing_consent_consent_title_3') }}</h2>

                                    <p class="article4__card-text">{{ $t('landing_consent_consent_description_3') }}</p>

                                </span>

                        </div>

                    </div>

                    <a class="btn btn-blue article4__btn" href="/my-data" target="_blank">En savoir plus</a>

                </article>

                <article class="article5__container">

                    <h2 class="article5__title">{{ $t('landing_consent_app_title') }}</h2>

                    <p class="article5__subtitle">{{ $t('landing_consent_app_subtitle') }}</p>

                    <div class="article5__badge-container">

                        <a @click="clickPhoneV4" :href="appleStoreRedirect"
                           target='_blank'><img v-lazy="lazy('/img/landing/appstore.svg')" class="article5__badge"></a>

                        <a @click="clickPhoneV4" href="https://app.adjust.com/uez2im" target='_blank'><img v-lazy="lazy('/img/landing/playstore.png')" class="article5__badge"></a>

                    </div>

                    <div class="article5__phone-container">

                        <img v-lazy="lazy(computedIosImg)" class="article5__phone">

                        <img v-lazy="lazy(computedAndroidImg)" class="article5__phone">

                    </div>

                    <img v-lazy="lazy('/img/landing/v4/background-wave.svg')" class="article5__wave">

                </article>

                <article class="article6__container">

                    <h2 class="article6__title">{{ $t('landing_web_questions_title') }}</h2>

                    <div class="article6__bloc-white-container">

                        <div class="article6__bloc-white">

                            <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_clean') }}</h3>

                            <p class="article6__bloc-text">{{ $t('landing_web_questions_text_clean') }}</p>

                        </div>

                        <div class="article6__bloc-white">

                            <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_carbon') }}</h3>

                            <p class="article6__bloc-text">{{ $t('landing_web_questions_text_carbon') }}</p>

                        </div>

                        <div class="article6__bloc-white">

                            <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_mistake') }}</h3>

                            <p class="article6__bloc-text">{{ $t('landing_web_questions_text_mistake') }}</p>

                        </div>

                        <div class="article6__bloc-white">

                            <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_forever') }}</h3>

                            <p class="article6__bloc-text">{{ $t('landing_web_questions_text_forever') }}</p>

                        </div>

                    </div>


                </article>

                <article class="article7__container">

                    <div class="article7__bloc">

                        <h2 class="article7__title">{{ $t('landing_consent_banner_title') }}</h2>

                        <p class="article7__subtitle">{{ $t('landing_consent_subtitle_description') }}</p>

                    </div>

                    <div class="article7__bloc">

                        <div class="article1__input-container" @click.self="focusInputV4">

                            <input class="article1__input" ref="inputv4bottom" :placeholder="$t('landing_web_placeholder')" v-on:keyup.enter="goLogin($refs.inputv4bottom.value, 'banner_cta')">

                            <button class="btn btn-green btn-big article1__button" @click="goLogin($refs.inputv4bottom.value, 'banner_cta')">
                                <lottie-loader v-if="requesting" class="btn-loader"></lottie-loader>
                                <span :class="{ 'btn-hidden':  requesting}">{{ $t('landing_consent_banner_cta') }}</span>
                            </button>

                            <img class="article1__input-logo" v-lazy="lazy('/img/partner/shine-white-right.svg')">

                        </div>

                    </div>

                </article>

                <article class="article8__container">

                    <h2 class="article8__title">Powered by</h2>

                    <img class="article8__logo" v-lazy="lazy('/img/landing/v4/foxintelligence-logo-black.png')">

                    <p class="article8__text">{{ $t('landing_consent_description_foxintelligence') }}</p>

                    <a class="btn article8__btn" target="_blank" rel="foxintelligence" href="https://www.foxintelligence.fr/" @click="clickAmplitude('cta_foxintelligence')">{{ $t('landing_consent_cta_foxintelligence') }}</a>

                </article>

                <footer-green></footer-green>

                <modal-error-provider :email="emailError" ref="MEP"></modal-error-provider>

            </main>

        </div>


    </div>

</template>

<script>

import Vuex from 'vuex'

import Api from '@/api'

import Storage from '@/helpers/storage'

import AbTesting from '@/modules/abTesting'
import I18n from '@/modules/i18n'
import Providers from '@/modules/providers'
import Tag from '@/modules/tag'
import Tracking from '@/modules/tracking'
import UserFlow from '@/modules/userFlow'

import Checkbox from '@/components/inputs/Checkbox'
import FooterLanding from '@/components/FooterLanding'
import FooterGreen from '@/components/FooterGreen'
import LandingCarrousel from '@/components/LandingCarrousel'
import LottieLoader from '@/components/lottie/LottieLoader'
import Markdown from '@/components/Markdown'
import ModalErrorProvider from '@/components/modal/ModalErrorProvider'
import Toast from '@/components/Toast'

export default {

    name: 'landing',

    components: {Checkbox, FooterLanding, FooterGreen, LandingCarrousel, LottieLoader, Markdown, ModalErrorProvider, Toast},

    computed: {

        ...Vuex.mapGetters([ 'loginEmail', 'lang' ]),

        appleStoreRedirect () {
            return `https://app.adjust.com/uez2im?deep_link=cleanfox://&redirect=https://itunes.apple.com/${ I18n.get(this) }/app/cleanfox/id1136298377?mt=8`
        },

        computedIosImg () {
            return `/img/landing/v4/iOS-${ I18n.get(this) }.png`
        },

        computedAndroidImg () {
            return `/img/landing/v4/android-${ I18n.get(this) }.png`
        }

    },

    watch: {
        $mq: function (value) {
            if(value !== 'lg') {
                this.startLanding('a')
            }
        }
    },

    data() {

        return {
            regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            emailError: '',
            pageVersion: '',
            isMaintenance: false,
            requesting: false
        }
    },

    mounted() {

        // save tracking before
        Tracking.saveTracking(this.$route.query)

        if(this.$mq === 'lg') {
            switch(Storage.getItem('landingConsent')) {
                case 'a':
                    this.startLanding('a')
                    break
                case 'b':
                    this.startLanding('b')
                    break
                default:
                    AbTesting.landingv4()
                        .then(data => {
                            if(data === 'b') {
                                this.startLanding('b')
                            } else {
                                this.startLanding('a')
                            }
                        })
                        .catch(() => {
                            this.startLanding('a')
                        })
            }
        } else {
            this.startLanding('a')
        }


        if (this.$route.params && this.$route.params.error) {

            this.$refs.toast.open()

        }

        UserFlow.setPage(this, 'landing_web')

        Api.server.healthCheck()
            .then(maintenance => {
                if (maintenance.status === 'maintenance') {
                    this.isMaintenance = true
                }
            })
            .catch(() => {
            })

    },

    methods: {

        ...Vuex.mapActions(['setEmail']),

        lazy(url) {
            return {src: url}
        },

        wantUseCleanfox(number) {

            Tag.clickGA(this, 'btn_top_' + number)
            this.$router.push({path: '/login/email'})

        },

        startLanding(version = 'a') {
            switch(version) {
                case 'a':
                    this.pageVersion = 'a'
                    UserFlow.setPage(this, 'landing_web')
                    Storage.setItem('landingConsent', 'a')
                    break
                case 'b':
                    this.pageVersion = 'b'
                    UserFlow.setPage(this, 'landing_consent')
                    Storage.setItem('landingConsent', 'b')
                    break
            }
        },

        clickPhoneV4 () {
            Tag.clickGA(this, 'app_download')
        },

        focusInputV4() {
            this.$refs.inputv4.focus()
        },
        goLogin (email, event) {
            if(this.regexMail.test(email)) {
                this.requesting = true
                Api.provider.get(email)
                    .then(data => {
                        this.setEmail(email)
                        Storage.setItem('lastProvider', data.provider)
                        Tag.clickAmplitude(this, event)
                        if(Providers.isSpecificProvider(data.provider)) {
                            this.$router.push({ path: `/login/${ data.provider }` })
                        } else {
                            this.$router.push({ path: '/login' })
                        }
                    })
                    .catch((error) =>  {
                        this.requesting = false
                        if (error.message === 'mx_unsupported') {
                            this.emailError = email
                            this.$refs.MEP.show()
                        }
                    })
            }
        },

        clickAndroid() {
            Tag.clickAll(this, 'btn_play_store')
        },

        clickIos() {
            Tag.clickAll(this, 'btn_apple_store')
        },

        isProd() {
            return window.location.hostname.indexOf('cleanfox.io') > -1
        },

        hrefConnect() {

            Tag.clickGA(this, 'login')
            return `/${I18n.get(this)}/login/email`
        },

        hrefMagicLink() {

            return `/${I18n.get(this)}/magic-request-email`
        },

        goTerms () {

            window.open('/terms')

        },

        goPrivacy () {

            window.open('/privacy')

        },

        clickGA(event) {

            Tag.clickGA(this, event)

        },

        clickAmplitude(event) {

            Tag.clickAmplitude(this, event)

        }

    }
}
</script>

<style src="./style.scss" lang="scss" scoped></style>

<style src="./stylev4.scss" lang="scss" scoped></style>

